const ComponentsLookup = {
  "local-partnership-page": "LocalPartnershipPage35ad53d55a8b4182Bf8b1374cacd5381",
  "default-footer": "DefaultFooter1ce00e2e46bf4344Bff5C5eb99362d6a",
  "default-header-top": "DefaultHeaderTopFd4a81549c634ca49839Ee69c8e0f9a4",
  "secondary-page": "SecondaryPageEd0dd5e87caa4cc89d73985790e7b15d",
  "secondary-marketing-header": "SecondaryMarketingHeader277710feDaf14b0eAff6C00eb69ec087",
  "secondary-marketing-hero": "SecondaryMarketingHero12dadd0b5f3b4e7eBa55C97a575513b1",
  "about-us-page": "AboutUsPageDde291d57380429d92b3B71ca3a77964",
  "public-events-page": "PublicEventsPageD3c1810eB29e4e97Bbb1Ebf98210ab3a",
  "join-us-page": "JoinUsPage7a3d3681C0fe400dBec1360f5ac7a908",
  "application-pages": "ApplicationPages1b7e46245cf84c7cB1ab2ad4d5cdd502",
  "public-contact-page": "PublicContactPage7580816dBf304a4fBb3227a7965a6491",
  "public-faq-page": "PublicFaqPageD1b033fc01824c699f633236d7c13e29",
  "home-page": "HomePage437b53df9db04fed9ae68caf2083dfb9"
}

export default ComponentsLookup;